/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import * as authServices from '../services/authService';
import * as accountServices from '../services/accountService'
import * as utilService from '../services/utilService'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
// import { ReCAPTCHA_KEY } from '../configs/const';
// import ReCAPTCHA from "react-google-recaptcha";
import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
import Loginb2cFooter from './loginb2cFooter';
import Joinnowpopup from './sub_components/joinnowpopup'
import Loginpopup from './sub_components/loginpopup'
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class Exchange extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection: "",
            clientWidth: document.documentElement.clientWidth,
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }



    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]: false })

    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })

    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = "") {
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name) {
        this.setState({ selectedSection: this.state.selectedSection === name ? "" : name });
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
            <div className="radheexch radheexchlogin bg-white-login vsportbg">
                <Loginb2cHeader history={this.props.history} selectedSection={this.state.selectedSection} toggleSelectedSection={(view) => this.toggleSelectedSection(view)} showSweetAlert={(options) => this.props.showSweetAlert(options)} notify={this.props.notify}></Loginb2cHeader>
                {/* <div className='login-mar-top100'>
            <section className='sportbook-screen'>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen.jpg"} className="sp-desktop-show" /></a>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen-mobile.jpg"} className="sp-mobile-show" /></a>
            </section>
        </div> */}
                <div className='login-mar-top100 bg-black'>
                    <section className='sportbook-livecasino'>
                        <div>
                            <img alt="Exchange Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchanges-banner.jpg"} />

                        </div>
                        <div>
                            <div className="livecasino-container">
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/cricket.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/horseracing.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item  ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/ex13.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/livestreaming.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/ex8.png"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="livecasino-item slots__item ">                            
                                <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/v12.jpg"} />
                                <div className='slots__bg'>
                                    <div className="slots__overlay">
                                        <div className="slots__favorite"></div> 
                                        <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                    </div>
                                </div>
                            </div> */}
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/bookmaker.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/greyhoundracing.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/esport.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/ex4.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/soccer.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/sportbettinglive.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/voteindia.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/virtualsports.jpg"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>


                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/ex14.png"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/ex15.png"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="livecasino-item slots__item ">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchangeimages/ex16.png"} />
                                    <div className='slots__bg'>
                                        <div className="slots__overlay">
                                            <div className="slots__favorite"></div>
                                            <a href="javascript:void(0)" className="slots__btn" onClick={(e) => { this.showPopup("Login") }}>Play</a>
                                        </div>
                                    </div>
                                </div>



                                {/* <div className="livecasino-item"><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evoluation/evoluation9.jpg"} /></div> */}
                            </div>

                        </div>
                    </section>
                </div>


                <Loginb2cFooter history={this.props.history}></Loginb2cFooter>


                {this.state.showPopup && <Joinnowpopup hidePopup={() => { this.hidePopup() }} showSweetAlert={(options) => { this.props.showSweetAlert(options) }} notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)} toggleSelectedSection={(name) => { this.toggleSelectedSection(name) }} />}
                {this.state.showLoginPopup && <Loginpopup hidePopup={() => { this.hidePopup("Login") }} showSweetAlert={(options) => { this.props.showSweetAlert(options) }} history={this.props.history} notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)} />}
            </div>)

    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Exchange);